import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { EnrollmentCountModel } from '../models/enrollment-count.model'
import { MyClientsCriteria } from '../models/my-clients-criteria'
import { EnrollmentReportSummaryModel } from '../models/enrollment-report-summary.model'
import { LeadType } from '../models/lead-type-model'
import { ListStatus } from '../models/list-status-model'
import { OnList } from '../models/enrollment-search-on'
import { EnrollmentSearch } from '../models/EnrollmentSearch'
import { SearchModel } from '../models/enrollment-search-details'
import { ReportsEnrollmentSearch } from '../models/reports-enrollment-search-status-model'
import { ExternalTrainingReport } from '../models/external-training-report'
import { GetEnrollmentRequest } from '../models/GetEnrollmentDataRequest'
import { GetEnrollmentDataResponse } from '../models/get-enrollment-data-response'
import { EnrollmentReportDetailsModel } from '../models/enrollment-report-details.model'
import { MedicareIDSearch } from '../models/MedicareIDSearch'
import { ExternlaTrainingSearchCriteria } from '../models/external-training-search-criteria'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'
import { UsersInactiveModel } from '../models/users-inactive.model'
import { UserProfileChangeModel } from '../models/UserProfile.model'
import { UserProfile } from '../models/user-profile'

@Injectable()
export abstract class ReportsGateway {
    private _myClientsCriteria: MyClientsCriteria = new MyClientsCriteria()
    private _myClientsCriteriaAU: MyClientsCriteria = new MyClientsCriteria()

    private _selectedUserForSummaryReport = {} as UserProfile
    private _fmoModel: SearchModel = new SearchModel()

    abstract getEnrollmentsCount(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentCountModel[]>
    abstract getEnrollmentsCountAU(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentCountModel[]>

    abstract getPWEnrollmentsCount(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentCountModel[]>
    abstract getPWEnrollmentsCountAU(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentCountModel[]>
    //	abstract getEnrollmentReportSummary(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentReportSummaryModel[]>
    abstract getEnrollmentAppDetails(getEnrollmentRequest: GetEnrollmentRequest): Observable<GetEnrollmentDataResponse[]>
    abstract getEnrollmentReportSummarySync(myClientsCriteria: MyClientsCriteria): EnrollmentReportSummaryModel[]

    abstract getEnrollmentReportSummary(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentReportSummaryModel[]>
    abstract getPWEnrollmentReportSummary(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentReportSummaryModel[]>

    abstract getEnrollmentReportSummaryAU(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentReportSummaryModel[]>
    abstract getPWEnrollmentReportSummaryAU(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentReportSummaryModel[]>
    abstract getAlternativeReportingEnabled(userProfileId: number): Observable<boolean>

    abstract getLeadTypes(): Observable<LeadType[]>
    abstract getStatusList(): Observable<ListStatus[]>
    abstract getSearchFilterList(): Observable<OnList[]>
    //abstract getCustomSearchList(ListValueId: number, Status: number, LeadTypeID: string, StartDate: string, EndDate: string): Observable<EnrollmentSearch[]>
    abstract getCustomSearchList(FmoModel: SearchModel): Observable<EnrollmentSearch[]>
    abstract getCustomSearchListSync(FmoModel: SearchModel): EnrollmentSearch[]
    abstract getIpadSearchList(FmoModel: SearchModel): Observable<EnrollmentSearch[]>
    abstract getIpadSearchListSync(FmoModel: SearchModel): EnrollmentSearch[]
    abstract getConsumerSearchList(FmoModel: SearchModel): Observable<EnrollmentSearch[]>
    abstract getConsumerSearchListSync(FmoModel: SearchModel): EnrollmentSearch[]
    abstract updateEnrollmentStatus(FmoModel: EnrollmentSearch): Observable<EnrollmentSearch[]>
    abstract getEnrollmentReportDetails(myClientsCriteria: MyClientsCriteria): Observable<EnrollmentReportDetailsModel>
    abstract getMedicareSearchData(searchText: string): Observable<MedicareIDSearch[]>
    abstract getMedicareSearchDataExport(searchText: string): Observable<MedicareIDSearch[]>
    abstract getWESLastAccess(): Observable<string>
    abstract getExternalTrainingReport(searchCriteria: ExternlaTrainingSearchCriteria): Observable<ExternalTrainingReport[]>
    abstract getCarrierList(orgID: number, state: string): Observable<ValidatedSelectOptionModel[]>
    abstract getCUIDList(orgID: number, state: string, carrierId: string): Observable<ValidatedSelectOptionModel[]>
    abstract getPlanTypeList(orgID: number, state: string, carrierId: string, cuid: string): Observable<ValidatedSelectOptionModel[]>
    abstract getAgentList(orgID: number, state: string, carrierId: string, cuid: string): Observable<ValidatedSelectOptionModel[]>

    abstract getInactiveUsers(searchCriteria: SearchModel): Observable<UsersInactiveModel[]>
    abstract getInactiveUsersSync(searchCriteria: SearchModel): UsersInactiveModel[]

    abstract getUserProfileChange(searchCriteria: SearchModel): Observable<UserProfileChangeModel[]>
    abstract getUserProfileChangeSync(searchCriteria: SearchModel): UserProfileChangeModel[]

    abstract getNewUsersAdded(searchCriteria: SearchModel): Observable<UsersInactiveModel[]>
    abstract getNewUsersAddedSync(searchCriteria: SearchModel): UsersInactiveModel[]

    abstract getAlternateUserProfiles(userProfileId: number): Observable<UserProfile[]>

    get myClientsCriteria(): MyClientsCriteria {
        return this._myClientsCriteria
    }
    set myClientsCriteria(value: MyClientsCriteria) {
        this._myClientsCriteria = value
    }

    get myClientsCriteriaAU(): MyClientsCriteria {
        return this._myClientsCriteriaAU
    }
    set myClientsCriteriaAU(value: MyClientsCriteria) {
        this._myClientsCriteriaAU = value
    }

    get selectedUserForSummaryReport(): UserProfile {
        return this._selectedUserForSummaryReport
    }

    set selectedUserForSummaryReport(value: UserProfile) {
        this._selectedUserForSummaryReport = value
    }

    get searchModel(): SearchModel {
        return this._fmoModel
    }
    set searchModel(value: SearchModel) {
        this._fmoModel = value
    }
}
